'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _cmsComponentUtilities = require('@viskan/cms-component-utilities');

var _dekuForm = require('@viskan/deku-form');

var _dekuButton = require('@viskan/deku-button');

var _dekuButton2 = _interopRequireDefault(_dekuButton);

var _viskanDekuRecaptcha = require('viskan-deku-recaptcha');

var _viskanDekuRecaptcha2 = _interopRequireDefault(_viskanDekuRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var name = 'CMS-Component-MessageForm';

var propTypes = {
	getTranslation: {
		source: 'getTranslation'
	}
};

var initialState = function initialState() {
	return { recaptcha_error: '' };
};

var getInputType = function getInputType(formEl, name) {
	var input = formEl.querySelector('input[name=\'' + name + '\']');

	return input && input.type;
};

var handleSubmit = function handleSubmit(props, setState) {
	return function (data, formEl) {
		if (props.useRecaptcha && !data['g-recaptcha-response']) {
			setState({ recaptcha_error: props.getTranslation('recaptcha.error') });
			return;
		}

		setState(initialState());

		var templateParameter = Object.keys(data).reduce(function (acc, key) {
			var inputType = getInputType(formEl, key);

			return key === 'g-recaptcha-response' ? acc : _extends({}, acc, _defineProperty({}, key, inputType === 'checkbox' ? Boolean(data[key]) : data[key]));
		}, {});

		v12.messages.post(props.template, {
			helpdesk: Boolean(props.helpdesk),
			helpdeskTagId: props.helpdeskTagId ? props.helpdeskTagId.split(',') : [],
			replyTo: props.replyToField ? data[props.replyToField] : '',
			templateParameter: templateParameter
		}).then(function () {
			setState({ successful: true });
			formEl.reset();
		}).catch(function () {
			return setState({ successful: false });
		});
	};
};

var render = function render(_ref, setState) {
	var props = _ref.props,
	    state = _ref.state;
	var reCAPTCHASiteKey = props.reCAPTCHASiteKey;


	return (0, _cmsComponentUtilities.createCmsComponent)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': [name, props.styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(
			_dekuForm.Form,
			{ onSubmit: handleSubmit(props, setState) },
			(0, _magicVirtualElement2.default)(
				'div',
				null,
				props.children
			),
			props.useRecaptcha && (0, _magicVirtualElement2.default)(
				'div',
				{ 'class': props.styleClasses.Recaptcha, 'data-style-attr': 'Recaptcha' },
				(0, _magicVirtualElement2.default)(_viskanDekuRecaptcha2.default, { siteKey: reCAPTCHASiteKey }),
				state.recaptcha_error && (0, _magicVirtualElement2.default)(
					'div',
					{ 'class': props.styleClasses.Recaptcha_Error_Message },
					state.recaptcha_error
				)
			),
			(0, _magicVirtualElement2.default)(
				_dekuButton2.default,
				{ styleClasses: props.styleClasses },
				props.submitName
			)
		),
		state.successful && (0, _magicVirtualElement2.default)('div', { 'class': props.styleClasses.Feedback_Message_Success, innerHTML: props.feedbackMessageSuccess }),
		!state.successful && typeof state.successful === 'boolean' && (0, _magicVirtualElement2.default)('div', { 'class': props.styleClasses.Feedback_Message_Error, innerHTML: props.feedbackMessageError }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Recaptcha_Error_Message' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Feedback_Message_Success' }),
		(0, _magicVirtualElement2.default)('noscript', { 'data-style-attr': 'Feedback_Message_Error' })
	), props);
};

exports.default = { render: render, name: name, initialState: initialState, propTypes: propTypes };